/* globals cookieManager, define*/
(function closure(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define('cookie-utils', [], function load() {
      return factory(root);
    });
  } else {
    root.cookieUtils = factory(root);
  }
}(this, function factory(root) {
  // @TODO - REMOVE THIS.
  if (typeof root.cookieUtils !== 'undefined') {
    return root.cookieUtils;
  }

  // Trim string of whitespaces
  function trim(stringToTrim) {
    return stringToTrim.replace(/^\s+|\s+$/g, '');
  }

  var cookieUtils = (typeof define === 'function' && define.amd) ? {} : root;
  var privateMethods = {};

  cookieUtils.sFULL = 'FULL';
  cookieUtils.iCOOKIE_EXP_SESSION = null;
  cookieUtils.sCOOKIE_NM_USER_AGENT_OVERRIDE = 'THD_USR_AGENT_OVERRIDE';


  // Modified WCS 7Up Code Merge 4.6 on 07/22/2011
  cookieUtils.cookieManager = (typeof cookieManager !== 'undefined') ? cookieManager : null;

  function hasValue(key) {
    if (typeof key === 'undefined' || key === null || key.toString().length === 0) {
      return false;
    }
    return true;
  }

  // escape is deprecated so we must use encode uri,
  // however we cant have a `(` or `)` in the cookie
  // value, which escape used to take care of
  cookieUtils._escapeCookie = function encodeCookie(cookieValue) {
    return encodeURIComponent(cookieValue)
      .replace(/\(/g, '%28')
      .replace(/\)/g, '%29');
  };

  cookieUtils.setMobileCookie = function setMobileCookie(cookieName, cookieValue, expirationDays, domain, _options) {
    var options = (_options) ? _options : {};
    if (typeof options.path === 'undefined') {
      options.path = '/';
    }

    var expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + expirationDays);
    var cookieString = cookieName + '=' + this._escapeCookie(cookieValue) + '; expires=' + ((expirationDays === null) ?
      '' :
      expirationDate.toUTCString()) + '; path=' + options.path + '; domain=' + domain;
    document.cookie = cookieString;
  };
  /* eslint-disable*/
  cookieUtils.fed_CreateCookie = function fed_CreateCookie(name, value, days) {
    /* eslint-enable*/
    var expires;
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  };
  /* eslint-disable*/
  cookieUtils.fed_ReadCookie = function fed_ReadCookie(name) {
    /* eslint-enable*/
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  };
  /* eslint-disable*/
  cookieUtils.fed_EraseCookie = function fed_EraseCookie(name) {
    /* eslint-enable*/
    cookieUtils.fed_CreateCookie(name, '', -1);
  };


  // Return wc user id based on cookie WC_USERACTIVITY_{userid}
  cookieUtils.getUserIdFromUserActivityCookie = function getUserIdFromUserActivityCookie() {
    var startsWithName = 'WC_USERACTIVITY_';
    var ca = document.cookie.split(';');
    var i;
    var c;
    for (i = 0; i < ca.length; i++) {
      c = trim(ca[i]);
      if (c.indexOf(startsWithName) === 0) {
        return c.substring(16, c.indexOf('='));
      }
    }
    return '';
  };


  /*
  Checks to see if cookie exists
  */
  cookieUtils.hasBrowserCookie = function hasBrowserCookie(name) {
    var nameEQ = name;
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return true;
      }
    }
    return false;
  };


  /*
        Returns value of browser cookie
  */
  cookieUtils.readBrowserCookie = function readBrowserCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
    }
    return '';
  };


  // Deletes browser cookie by expiring it
  cookieUtils.deleteBrowserCookie = function deleteBrowserCookie(name, domain) {
    var date = new Date();
    var expires = '; expires=' + date.toString();
    document.cookie = name + '=' + expires + '; path=/; domain=' + domain;
  };

  // Should belong in cookie-utils but only THD_CUSTOMER
  // is decoded for global analytics
  cookieUtils.getJWTPayload = function getJWTPayload(cookie) {
    if (cookie) {
      var JWT = cookie.split('.');
      return JWT.length === 3 ? JWT[1] : JWT[0];
    }

    return null;
  };

  cookieUtils.parseJWTCookie = function parseJWTCookie(cookieName) {
    var JWT = cookieUtils.fed_ReadCookie(cookieName);
    var JWTPayload = cookieUtils.getJWTPayload(JWT);

    try {
      return JSON.parse(window.atob(JWTPayload));
    } catch (err) {
      return null;
    }
  };

  /*
        This will create either a browser cookie or a cookie crumb
        this exists inside a master cookie
  */
  cookieUtils.createCookie = function createCookie(name, value, days) {
    if (hasValue(cookieUtils.cookieManager)) {
      cookieUtils.cookieManager.createCookie(name, value, days);
    }
  };

  /*
  Don't use the domain value being passed in, just use the default domain
  */
  cookieUtils.createCookieWDomain = function createCookieWDomain(name, value, days /* , domain */ ) {
    cookieUtils.cookieManager.createCookie(name, value, days);
  };

  cookieUtils._getDocumentDomain = function _getDocumentDomain() {
    return document.domain;
  };

  /*
    Determine if the default domain should be used or
    if the domain of the document should be used instead
    It should be noted that the document.domain will return
    the fully qualified hostname, not just the domain name.
    The implication is that the value returned will NOT have
    a leading period.
  */
  cookieUtils.getCurrentDomain = function getCurrentDomain(defaultDomain) {
    var currentDomain = defaultDomain;
    var documentDomain = this._getDocumentDomain();
    var dotDocumentDomain = '.' + documentDomain;
    if (dotDocumentDomain.indexOf(currentDomain) === -1) {
      var domainRegex = /((\.?hd-\w+)?\.?\w+.com)/;
      currentDomain = (currentDomain && currentDomain.indexOf('hd-') !== -1) ?
        domainRegex.exec(currentDomain) :
        domainRegex.exec(dotDocumentDomain);
      if (currentDomain && currentDomain.length) {
        currentDomain = currentDomain[1];
      }
    }
    return currentDomain;
  };

  cookieUtils.setCookieExpireInSeconds = function setCookieExpireInSeconds(cookieName, cookieValue, expInSec, _domain) {
    var domain = (typeof _domain !== 'undefined') ? _domain : null;
    var expDt = new Date();
    expDt.setTime(expDt.getTime() + (expInSec * 1000));
    var expDtString = (expDt === null) ? '' : expDt.toUTCString();
    var cookieString = cookieName + '=' + this._escapeCookie(cookieValue) + '; expires=' + expDtString + '; path=/;';

    if (domain) {
      cookieString += ' domain=' + domain;
    }

    document.cookie = cookieString;
  };

  // Creates a session only cookie
  cookieUtils.setSessionOnlyCookie = function setSessionOnlyCookie(cookieName, cookieValue, domain) {
    var cookieString = cookieName + '=' + cookieValue + '; path=/;';
    if (domain) {
      cookieString += ' domain=' + domain;
    }
    document.cookie = cookieString;
  };

  cookieUtils.initializeMasterCookie = function initializeMasterCookie() {
    cookieUtils.cookieManager.initializeMasterCookie();
  };

  // Initialize the CookieManager
  cookieUtils.initializeCookieManager = function initializeCookieManager(cookieDomain) {
    if (cookieUtils.cookieManager) return cookieUtils.cookieManager;

    var xmlString = '';
    xmlString = ['<cookies domain="" path="/" regular_delimiter=":;" cache_delimiter="_~" regular_equals="=" cache_equals="~" expiration_suffix="_EXP">',
      '<cookie type="R" name="THD_PERSIST" expiration="51840000" path="/"></cookie>',
      '<cookie type="R" name="THD_SESSION" expiration="-1" path="/"></cookie>',
      '<cookie type="C" name="THD_CACHE_NAV_SESSION" expiration="-1" path="/"></cookie>',
      '<cookie type="C" name="THD_CACHE_NAV_PERSIST" expiration="51840000" path="/"></cookie>',
      '</cookies>',
      '<crumbs>',
      '<crumb type="R" alias="THD_BROWSESTATUS" name="C1" exp="-1"></crumb>',
      '<crumb type="R" alias="CJInfo" name="C2" exp="2592000"></crumb>',
      '<crumb type="C" alias="THD_KIOSK" name="C3" exp="" cookie="THD_CACHE_NAV_PERSIST"></crumb>',
      '<crumb type="R" alias="THD_LOCSTORE" name="C4" exp="51840000"></crumb>',
      '<crumb type="R" alias="THD_LOCSTOREFILTER" name="C5" exp="51840000"></crumb>',
      '<crumb type="R" alias="THD_MINICART" name="C6" exp="2592000"></crumb>',
      '<crumb type="R" alias="THD_MINILIST" name="C7" exp="51840000"></crumb>',
      '<crumb type="R" alias="THD_REFERRER" name="C8" exp="86400"></crumb>',
      '<crumb type="R" alias="THD_REMEMBERME" name="C9" exp="51840000"></crumb>',
      '<crumb type="C" alias="RPP" name="C10" exp="" cookie="THD_CACHE_NAV_PERSIST"></crumb>',
      '<crumb type="C" alias="THD_SPLASSORT" name="C11" exp="" cookie="THD_CACHE_NAV_SESSION"></crumb>',
      '<crumb type="R" alias="THD_USEREMAIL" name="C12" exp="51840000"></crumb>',
      '<crumb type="R" alias="THD_USERNAME" name="C13" exp="51840000"></crumb>',
      '<crumb type="R" alias="THD_USERSTATUS" name="C14" exp="-1"></crumb>',
      '<crumb type="R" alias="THD_GRMODE" name="C15" exp="-1"></crumb>',
      '<crumb type="R" alias="THD_AOL" name="C16" exp="-1"></crumb>',
      '<crumb type="R" alias="THD_USERREGTYPE" name="C17" exp="86400"></crumb>',
      '<crumb type="R" alias="THD_USERREF" name="C18" exp="86400"></crumb>',
      '<crumb type="R" alias="THD_ZIPCODE" name="C19" exp="86400"></crumb>',
      '<crumb type="C" alias="THD_NAVONLINESTORE" name="C20" exp="" cookie="THD_CACHE_NAV_SESSION"></crumb>',
      '<crumb type="C" alias="THD_NAVLOCALSTORE" name="C22" exp="" cookie="THD_CACHE_NAV_SESSION"></crumb>',
      '<crumb type="R" alias="THD_STRFINDERZIP" name="C24" exp="51840000"></crumb>',
      '<crumb type="R" alias="THD_ADMIN_HOST_INFO" name="C25" exp="51840000"></crumb>',
      '<crumb type="C" alias="THD_USERSORTOPTION" name="C26" exp="" cookie="THD_CACHE_NAV_SESSION"></crumb>',
      '<crumb type="R" alias="THD_AUTOLOCALIZEZIP" name="C27" exp="51840000"></crumb>',
      '<crumb type="R" alias="THD_AUTOLOCINTERCEPT" name="C29" exp="-1"></crumb>',
      '<crumb type="R" alias="THD_CA_USER" name="C30" exp="-1"></crumb>',
      '<crumb type="R" alias="THD_REQUIRED_PARTS_SELECTION" name="C31" exp="-1"></crumb>',
      '<crumb type="R" alias="THD_PASS_TEMP_VAL" name="C32" exp="51840000"></crumb>',
      '<crumb type="R" alias="THD_PREVIOUS_LOCAL_STORE" name="C33" exp="51840000"></crumb>',
      '<crumb type="R" alias="FEATURE_THROTTLE" name="C34" exp="86400"></crumb>',
      '<crumb type="R" alias="THD_LIVEPERSON_ERRORCOUNT" name="C35" exp="86400"></crumb>',
      '<crumb type="R" alias="THD_GEOLOCATION_INFO" name="C36" exp="-1"></crumb>',
      '<crumb type="R" alias="THD_AUTOLOCALIZED_SESSION" name="C37" exp="-1"></crumb>',
      '<crumb type="R" alias="THD_STORE_HOURS" name="C39" exp="3600"></crumb>',
      '<crumb type="R" alias="THD_USER_ID" name="C43" exp="51840000" cookie="THD_PERSIST"></crumb>',
      '<crumb type="R" alias="NONTLS_THD_AUTHORIZATION_TOKEN" name="C44" exp="51840000" cookie="THD_PERSIST"></crumb>',
      '<crumb type="R" alias="THD_AUTHORIZATION_TOKEN" name="C45" exp="51840000" cookie="THD_PERSIST"></crumb>',
      '<crumb type="R" alias="THD_USER_AUTH_STATUS" name="C46" exp="51840000" cookie="THD_PERSIST"></crumb>',
      '<crumb type="R" alias="THD_USERTYPE" name="C40" exp="51840000" cookie="THD_PERSIST"></crumb>',
      '<crumb type="R" alias="THD_BODFS_ZIPCODE" name="C41" exp="-1"/></crumb>',
      '<crumb type="C" alias="PLP_LAYOUTSTYLE" name="C42" exp="" cookie="THD_CACHE_NAV_SESSION"></crumb>',
      '<crumb type="C" alias="THD_DC_REFINEMENT" name="C47" exp="" cookie="THD_CACHE_NAV_PERSIST"></crumb>',
      '<crumb type="R" alias="THD_STORE_BANNER_STATUS" name="C51" exp="51840000"></crumb>',
      '</crumbs>'
    ].join('\n');

    var cookieJar = document.createElement('cookieJar');
    cookieJar.innerHTML = xmlString;
    document.getElementsByTagName('head')[0].appendChild(cookieJar);
    cookieUtils.cookieManager = new cookieUtils.CookieManager();
    cookieUtils.cookieManager.setCookieDomain(cookieUtils.getCurrentDomain(cookieDomain));
    // Initialize all the master cookies in config
    cookieUtils.cookieManager.initializeMasterCookie();
    return cookieUtils.cookieManager;
  };

  /*
       Creates a CookieManager object that manages MasterCookie objects
       PARAMETER: xmlId - The id of the XML island used to reference config data
  */
  cookieUtils.CookieManager = function CookieManager() {
    this.masterCookies = {};
    this.masterCookiesLength = 0;
    this.cookieDomain = '';
    this.path = '';
    this.cookieDelimiter = '';
    this.regularDelimiter = '';
    this.cacheDelimiter = '';
    this.regularEquals = '';
    this.cacheEquals = '';
    this.expiration_suffix = '';
  };

  cookieUtils.CookieManager.prototype.getCookiePath = function getCookiePath() {
    return this.path;
  };

  cookieUtils.CookieManager.prototype.setCookiePath = function setCookiePath(path) {
    this.path = path;
  };

  cookieUtils.CookieManager.prototype.getCookieExpirationSuffix = function getCookieExpirationSuffix() {
    return this.expiration_suffix;
  };

  cookieUtils.CookieManager.prototype.setCookieExpirationSuffix = function setCookieExpirationSuffix(suffix) {
    this.expiration_suffix = suffix;
  };

  cookieUtils.CookieManager.prototype.getRegularDelimiter = function getRegularDelimiter() {
    return this.regularDelimiter;
  };

  cookieUtils.CookieManager.prototype.setRegularDelimiter = function setRegularDelimiter(delimiter) {
    this.regularDelimiter = delimiter;
  };

  cookieUtils.CookieManager.prototype.getCacheDelimiter = function getCacheDelimiter() {
    return this.cacheDelimiter;
  };

  cookieUtils.CookieManager.prototype.setCacheDelimiter = function setCacheDelimiter(delimiter) {
    this.cacheDelimiter = delimiter;
  };

  cookieUtils.CookieManager.prototype.getCookieDomain = function getCookieDomain() {
    return this.cookieDomain;
  };

  cookieUtils.CookieManager.prototype.setCookieDomain = function setCookieDomain(domain) {
    this.cookieDomain = domain;
  };


  /*
      Get the crumbType for a given crumb name
  */
  cookieUtils.CookieManager.prototype.getCrumbType = function getCrumbType(crumbName) {
    var crumbList = document.getElementsByTagName('crumb');
    // Iterate through all the crumb entries to find the one
    // that matches the one that the caller wants
    for (var i = 0; i < crumbList.length; i++) {
      var crumbNode = crumbList[i];
      var currentCrumbName = crumbNode.getAttribute('name');

      // Alias name matches what is in config for this cookieName
      if (currentCrumbName === crumbName) {
        return crumbNode.getAttribute('type');
      }
    }

    return null;
  };
  /*
      Get the Cookie name for a cache crumb
  */
  cookieUtils.CookieManager.prototype.getCrumbCookieName = function getCrumbCookieName(crumbName) {
    var crumbList = document.getElementsByTagName('crumb');
    // Iterate through all the crumb entries to find the one
    // that matches the one that the caller want
    for (var i = 0; i < crumbList.length; i++) {
      var crumbNode = crumbList[i];
      var currentCrumbName = crumbNode.getAttribute('name');

      // Alias name matches what is in config for this cookieName
      if (currentCrumbName === crumbName) {
        return crumbNode.getAttribute('cookie');
      }
    }
    return null;
  };


  /*
        This initializes the CookieManager to create the necessary in-memory data structures
        of the cookies and their associated crumbs.
  */
  cookieUtils.CookieManager.prototype.initializeMasterCookie = function initializeMasterCookie() {
    var cookies = document.getElementsByTagName('cookies')[0];
    // Uncomment when the domain is dynamic
    // this.setCookieDomain(cookies.getAttribute('domain'));
    this.setCookieExpirationSuffix(cookies.getAttribute('expiration_suffix'));
    this.cacheDelimiter = cookies.getAttribute('cache_delimiter');
    this.regularDelimiter = cookies.getAttribute('regular_delimiter');
    this.cacheEquals = cookies.getAttribute('cache_equals');
    this.regularEquals = cookies.getAttribute('regular_equals');
    this.setCookiePath(cookies.getAttribute('path'));

    var masterCookieList = document.getElementsByTagName('cookie');

    for (var i = 0; i < masterCookieList.length; i++) {
      var objNode = masterCookieList[i];
      var cookieName = objNode.getAttribute('name');
      var cookieExpiration;
      if (objNode.getAttribute('expiration') !== -1) {
        cookieExpiration = parseInt(objNode.getAttribute('expiration'), 10) * 1000;
      } else {
        cookieExpiration = parseInt(objNode.getAttribute('expiration'), 10);
      }

      var cookiePath = this.getCookiePath();
      var cookieType = objNode.getAttribute('type');

      // Check if the cookie exists already
      // If not, create it
      var cookieValue = cookieUtils.readBrowserCookie(cookieName);
      var delimiter;
      var equals;

      if (cookieType === 'R') {
        delimiter = this.regularDelimiter;
        equals = this.regularEquals;
      } else {
        delimiter = this.cacheDelimiter;
        equals = this.cacheEquals;
      }

      this.masterCookies[cookieName] = new cookieUtils.MasterCookie(cookieName, cookieValue, cookieType, cookiePath, cookieExpiration, this.cookieDomain, equals, delimiter, this.getCookieExpirationSuffix());
      ++this.masterCookiesLength;

      if (!cookieUtils.hasBrowserCookie(cookieName)) {
        document.cookie = this.masterCookies[cookieName].makeCookieString();
      }
    }
  };


  /*
        Retrieves a cookie crumb value
        PARAMETER: cookieName - The alias of a cookie crumb whose value is to be retrieved
  */
  cookieUtils.CookieManager.prototype.readCookie = function readCookie(cookieName) {
    var aliasList = document.getElementsByTagName('crumb');
    var crumbFound = false;
    var cookieCrumb;
    for (var i = 0; i < aliasList.length; i++) {
      var aliasNode = aliasList[i];
      var aliasName = aliasNode.getAttribute('alias');
      var crumbName = aliasNode.getAttribute('name');
      var masterCookieName;
      cookieCrumb = null;
      if (aliasName === cookieName) {
        var crumbType = this.getCrumbType(crumbName);
        if (crumbType === 'R') {
          // Look through all the master cookies and remove the crumb if found
          // then retrieve the crumb.
          var masterCookieList = document.getElementsByTagName('cookie');

          for (var j = 0; j < masterCookieList.length; j++) {
            var objNode = masterCookieList[j];
            masterCookieName = objNode.getAttribute('name');
            // Check if alias name matches any entry in the config
            crumbFound = true;
            if (this.masterCookies[masterCookieName] !== null) {
              cookieCrumb = this.masterCookies[masterCookieName].getCrumb(crumbName);

              // If the crumb is not NULL then we have found it
              // Otherwise continue looking for crumb in based on
              // Additional aliases if they exist in the config
              if (cookieCrumb !== null) {
                return decodeURIComponent(cookieCrumb.getValue());
              }
            }
          }
        } else {
          // Check if alias name matches any entry in the config
          masterCookieName = this.getCrumbCookieName(crumbName);
          cookieCrumb = this.masterCookies[masterCookieName].getCrumb(crumbName);
          crumbFound = true;

          // If the crumb is not NULL then we have found it
          // Otherwise continue looking for crumb in based on
          // Additional aliases if they exist in the config
          if (cookieCrumb !== null) {
            return decodeURIComponent(cookieCrumb.getValue());
          }
        }
      }
    }

    // CookieName parameter doesn't match any alias names in config
    // so it must be a real cookie being requested
    if (crumbFound && cookieCrumb === null) {
      return '';
    }

    if (!crumbFound) {
      return cookieUtils.readBrowserCookie(cookieName);
    }
    return null;
  };

  /*
      This function determines if the expirations are the same length, i.e. they are both
      session or both actual expiration values
      PARAMETER: expirationValue1 - The expiration of the master cookie
      PARAMETER: expirationValue2 - The expiration to the cookie crumb
  */
  cookieUtils.CookieManager.prototype.hasSameExpiration = function hasSameExpiration(expirationValue1, expirationValue2) {
    if (Number(expirationValue1) === -1 && Number(expirationValue2) === -1) {
      return true;
    }
    if (Number(expirationValue1) === -1 && Number(expirationValue2) === 0) {
      return true;
    }
    if (Number(expirationValue1) > 0 && Number(expirationValue2) > 0) {
      return true;
    }

    return false;
  };


  /*
    Create a new cookie based on parameters
    PARAMETER: cookieName - The alias of the cookie crumb to be created
    PARAMETER: cookieValue - The value of the cookie crumb to be created
    PARAMETER: cookieExpiration - The expiration in days of the cookie crumb to be created
  */
  cookieUtils.CookieManager.prototype.createCookie = function createCookie(cookieName, cookieValue, _cookieExpiration) {
    var aliasList = document.getElementsByTagName('crumb');
    var cookieCrumb = null;
    var masterCookieName;
    var cookieExpiration = _cookieExpiration;
    // Iterate through all the alias entries to fins the one
    // that matches the one that the caller wants to add
    for (var i = 0; i < aliasList.length; i++) {
      var aliasNode = aliasList[i];
      var aliasName = aliasNode.getAttribute('alias');
      var crumbName = aliasNode.getAttribute('name');
      // Alias name matches what is in config for this cookieName
      if (aliasName === cookieName) {
        var crumbType = this.getCrumbType(crumbName);
        if (crumbType === 'R') {
          // Convert the expiration to -1 from empty string since the server code is interpreting
          // a session crumb in that manner.
          if (cookieExpiration === '' || cookieExpiration === null) {
            cookieExpiration = -1;
          }

          // Look through all the master cookies and remove the crumb if found
          // then add the crumb to the appropriate cookie.
          var masterCookieList = document.getElementsByTagName('cookie');

          for (var j = 0; j < masterCookieList.length; j++) {
            var objNode = masterCookieList[j];
            masterCookieName = objNode.getAttribute('name');
            // Always attempt to remove crumb
            this.masterCookies[masterCookieName].removeCrumb(cookieName);

            // Check if the expirations are the same.
            // If so, add the new crumb to the master cookie
            if (this.hasSameExpiration(this.masterCookies[masterCookieName].getConfigExpiration(), cookieExpiration)) {
              cookieCrumb = new cookieUtils.CookieCrumb(crumbName, cookieValue, cookieExpiration);

              // console.log(crumbName+' | '+cookieValue+' | '+cookieExpiration);

              this.masterCookies[masterCookieName].addCrumb(cookieCrumb);

              // Recreate the new master cookie in the browser.
              document.cookie = this.masterCookies[masterCookieName].makeCookieString();
              break;
            }
          }
        } else {
          masterCookieName = this.getCrumbCookieName(crumbName);
          cookieCrumb = new cookieUtils.CookieCrumb(crumbName, cookieValue, cookieExpiration);
          this.masterCookies[masterCookieName].addCrumb(cookieCrumb);

          // Recreate the new master cookie in the browser.
          document.cookie = this.masterCookies[masterCookieName].makeCookieString();
        }
        break;
      }
    }
  };


  /*
    Removes a cookie crumb object
    PARAMETER: cookieName - The alias of a cookie crumb to be deleted
  */
  cookieUtils.CookieManager.prototype.removeCookie = function removeCookie(cookieName) {
    var aliasList = document.getElementsByTagName('crumb');
    var crumbFound = false;
    var masterCookieName;
    for (var i = 0; i < aliasList.length; i++) {
      var aliasNode = aliasList[i];
      var aliasName = aliasNode.getAttribute('alias');
      var crumbName = aliasNode.getAttribute('name');

      // Check if alias name matches any entry in the config
      if (aliasName === cookieName) {
        var crumbType = this.getCrumbType(crumbName);
        if (crumbType === 'R') {
          // Look through all the master cookies and remove the crumb if found
          // A crumb should only exist in one master cookie at a time
          var masterCookieList = document.getElementsByTagName('cookie');

          for (var j = 0; j < masterCookieList.length; j++) {
            var objNode = masterCookieList[j];
            masterCookieName = objNode.getAttribute('name');

            crumbFound = true;
            this.masterCookies[masterCookieName].removeCrumb(crumbName);
            break;
          }
        } else {
          masterCookieName = this.getCrumbCookieName(crumbName);
          this.masterCookies[masterCookieName].removeCrumb(crumbName);
          crumbFound = true;
        }
        break;
      }
    }

    // CookieName parameter doesn't match any alias names in config
    // so it must be a real cookie being requested
    if (!crumbFound) {
      return cookieUtils.deleteBrowserCookie(cookieName);
    }
    return null;
  };


  /*
    Creates a MasterCookie object that contains CookieCrumb objects
    Expiration for each master cookie is stored in milliseconds where the value will be
    cookie expiration = expiration(milliseconds) + current time(milliseconds).
    PARAMETER: name - The name of a MasterCookie that should be in configuration
    PARAMETER: value - The unparsed value of a MasterCookie that the  browser contains
                      The value parameter is parsed and CookieCrumb objects are created.
    PARAMETER: type - The type of the MasterCookie, R - Regular, C - Cache
    PARAMETER: path - The path of the MasterCookie which should come from configuration
    PARAMETER: expiration - The number of milliseconds from now the master cookie is set to expire
    PARAMETER: domain - The domain of the cookie
    PARAMETER: equals - The value used to separate the crumb name and its value
    PARAMETER: delimiter - The delimiter used to separate cookie crumbs
    PARAMETER: expSuffix - The expiration suffix used for cookie crumbs
  */
  cookieUtils.MasterCookie = function MasterCookie(name, value, type, path, expiration, domain, equals, delimiter, expSuffix) {
    this.crumbArray = [];
    this.name = name;
    this.value = value;
    this.type = type;
    this.path = path;


    this.expiration = expiration;
    this.configExpiration = expiration;


    this.equals = equals;
    this.delimiter = delimiter;
    this.cookieDomain = domain;
    this.expirationSuffix = expSuffix;
    // This will setup the in-memory data structures for use later
    this.initialize();
  };

  cookieUtils.MasterCookie.prototype.getExpiration = function getExpiration() {
    return this.expiration;
  };

  cookieUtils.MasterCookie.prototype.getConfigExpiration = function getConfigExpiration() {
    return this.configExpiration;
  };

  cookieUtils.MasterCookie.prototype.isRegularType = function isRegularType() {
    if (this.type === 'R') {
      return true;
    }
    return false;
  };

  cookieUtils.MasterCookie.prototype.isCacheType = function isCacheType() {
    if (this.type === 'C') {
      return true;
    }
    return false;
  };


  /*
      Adjust the master cookie expiration to the latest expiration
      of the crumbs contained within it. This only applies to Regular Cookies.
  */
  cookieUtils.MasterCookie.prototype.updateToLatestExpiration = function updateToLatestExpiration() {
    // The master cookie my be a session cookie so check for empty string
    if (Number(this.expiration) !== -1) {
      var date = new Date();
      var currentExpirationValue = this.expiration;

      if (this.isRegularType()) {
        // Get the crumb with the latest expiration
        for (var i = 0; i < this.crumbArray.length; i++) {
          if (currentExpirationValue < (this.crumbArray[i].getExpiration())) {
            currentExpirationValue = this.crumbArray[i].getExpiration();
          }
        }
      }

      if ((parseInt(currentExpirationValue, 10) - date.getTime() > (24 * 60 * 60 * 1000))) {
        // Convert milliseconds back into days
        this.expiration = currentExpirationValue;
      } else {
        // Expire cookies after one day
        this.expiration = date.getTime() + (24 * 60 * 60 * 1000);
      }
    }
  };

  /*
      This function will check if the crumb already exists
      and then attempt to remove it. Then it will add the crumb
      to the master cookie
  */
  cookieUtils.MasterCookie.prototype.addCrumb = function addCrumb(crumb) {
    if (crumb !== null && crumb instanceof cookieUtils.CookieCrumb) {
      var crumbName = crumb.getName();
      for (var i = 0; i < this.crumbArray.length; i++) {
        if (this.crumbArray[i].getName() === crumbName) {
          this.removeCrumb(crumbName);
        }
      }
      this.crumbArray.push(crumb);
      this.updateToLatestExpiration();
    }
  };


  /*
    This function will remove a crumb from the master cookie
    and adjust the expiration date based on the cooies inside of it.
  */
  cookieUtils.MasterCookie.prototype.removeCrumb = function removeCrumb(crumbName) {
    for (var i = 0; i < this.crumbArray.length; i++) {
      if (this.crumbArray[i].getName() === crumbName) {
        this.crumbArray.splice(i, 1);
      }
    }

    if (this.isRegularType()) {
      // Set expiration of master cookie to default value defined in config
      // if there are no crumbs left
      if (this.crumbArray.length === 0) {
        this.expiration = new Date().getTime() + (this.configExpiration * 1000);
      } else {
        this.updateToLatestExpiration();
      }
    }
  };

  /*
      Returns the requested crumb to the caller
      If not found, returns null.
  */
  cookieUtils.MasterCookie.prototype.getCrumb = function getCrumb(crumbName) {
    for (var i = 0; i < this.crumbArray.length; i++) {
      if (this.crumbArray[i].getName() === crumbName) {
        if (this.isRegularType()) {
          // Remove the crumb if it has already expired
          if (Number(this.crumbArray[i].getExpiration()) !== -1) {
            var date = new Date();
            if (this.crumbArray[i].getExpiration() < date.getTime()) {
              this.crumbArray.splice(i, 1);
              break;
            }
          }
        }
        return this.crumbArray[i];
      }
    }
    // Crumb was not found or has expired
    return null;
  };

  /*
      This will convert the string representation of the current
      master cookie instance into a browser cookie
  */
  cookieUtils.MasterCookie.prototype.makeCookieString = function makeCookieString() {
    var expiresValue = '';

    if (this.expiration !== null && String(this.expiration) !== '' && parseInt(this.expiration, 10) > 0) {
      var date = new Date();
      date.setTime(parseInt(this.expiration, 10));
      expiresValue = '; expires=' + date.toGMTString();
    } else if (parseInt(this.expiration, 10) === -1) {
      expiresValue = '; expires=-1';
    } else {
      expiresValue = ';';
    }

    var pathValue;
    if (this.path !== null && this.path !== '') {
      pathValue = '; path=' + this.path;
    } else {
      pathValue = ';';
    }

    var domainValue;
    if (this.cookieDomain !== null && this.cookieDomain !== '') {
      domainValue = '; domain=' + this.cookieDomain;
    } else {
      domainValue = ';';
    }

    return this.name + '=' + cookieUtils._escapeCookie(this.makeCookieCrumbString()) + pathValue + domainValue + expiresValue;
  };


  /*
      Sort the crumbs based on name
  */
  cookieUtils.MasterCookie.prototype.sortCrumbs = function sortCrumbs(a, b) {
    var crumbAName = a.getName();
    var crumbBName = b.getName();
    var sortA = parseInt(crumbAName.substr(1), 10);
    var sortB = parseInt(crumbBName.substr(1), 10);

    if (sortA < sortB) {
      return -1;
    }
    if (sortA === sortB) {
      return 0;
    }
    if (sortA > sortB) {
      return 1;
    }
    return null;
  };


  /*
      This will convert all the cookie crumbs into a string
      that will get set to the value of the containing master cookie
  */
  cookieUtils.MasterCookie.prototype.makeCookieCrumbString = function makeCookieCrumbString() {
    var crumbString = '';
    this.crumbArray.sort(this.sortCrumbs);
    for (var i = 0; i < this.crumbArray.length; i++) {
      if (crumbString !== '') {
        crumbString += this.delimiter;
      }
      crumbString += this.crumbArray[i].getName() + this.equals + this.crumbArray[i].getValue();

      var crumbExp = this.equals;
      if (this.isRegularType()) {
        crumbExp += this.crumbArray[i].getExpirationInSeconds();
      }

      crumbString += this.delimiter + this.crumbArray[i].getName() + this.expirationSuffix + crumbExp;
    }
    return crumbString;
  };


  /*
      Parse the value into crumbs based off of the delimiter
  */
  cookieUtils.MasterCookie.prototype.initialize = function initialize() {
    if (this.value !== null && this.value !== '') {
      var cookieCrumbArray = this.value.split(this.delimiter);

      for (var i = 0; i < cookieCrumbArray.length; i = i + 2) {
        var crumbString = cookieCrumbArray[i];
        var index = crumbString.indexOf(this.equals);
        var name = crumbString.substring(0, index);
        var value = crumbString.substring(index + 1, crumbString.length);

        var crumbObject = null;
        var crumbExpiration = '';

        if (this.isRegularType()) {
          // Parse Expiration info
          crumbString = cookieCrumbArray[i + 1];
          // Defect # 8794
          if (crumbString !== null && typeof crumbString !== 'undefined') {
            index = crumbString.indexOf(this.equals);
            crumbExpiration = crumbString.substring(index + 1, crumbString.length);
          }

          if (Number(crumbExpiration) !== -1) {
            // Convert seconds back into milliseconds since that is what the interface specifies
            crumbExpiration = parseInt(crumbExpiration, 10) * 1000;
            crumbObject = new cookieUtils.CookieCrumb(name, value, null);
            crumbObject.setExpiration(crumbExpiration);
          } else {
            crumbObject = new cookieUtils.CookieCrumb(name, value, crumbExpiration);
          }
        } else {
          crumbObject = new cookieUtils.CookieCrumb(name, value, null);
          crumbObject.setExpiration('');
        }
        this.addCrumb(crumbObject);
      }
    }

    // Initialize the real expiration date of cookie here
    if (Number(this.expiration) !== -1) {
      var date = new Date();
      this.expiration = parseInt(this.configExpiration, 10) + date.getTime();
    }

    this.updateToLatestExpiration();
  };

  /*
    Creates a CookieCrumb object that contains info about a logical cookie
    Expiration for each cookie crumb is stored in milliseconds where the value will be
    cookie crumb expiration = expiration(milliseconds) + current time(milliseconds).
    PARAMETER: name - The name of the crumb.
    PARAMETER: value - The unparsed value of the crumb.
    PARAMETER: expiration - The number of days until the cookie expires
  */
  cookieUtils.CookieCrumb = function CookieCrumb(name, value, expiration) {
    // console.log('CookieCrumb Running');

    this.name = name;
    this.value = value;

    // console.log(this.value)

    // A null expiration means that the expiration value should be set explicitly
    // by calling the setExpiration method
    if (expiration !== null) {
      if (expiration !== '' && expiration > 0) {
        var date = new Date();
        date.setTime(date.getTime() + (parseInt(expiration * 24 * 60, 10) * 60 * 1000));
        this.expiration = date.getTime();
      } else if (expiration < 0 || expiration === '') {
        // This means the cookie is a session crumb
        this.expiration = -1;
      } else {
        // A zero means to expire the crumb
        this.expiration = 0;
      }
    }
  };

  cookieUtils.CookieCrumb.prototype.getName = function getName() {
    return this.name;
  };

  cookieUtils.CookieCrumb.prototype.getValue = function getValue() {
    return this.value;
  };

  cookieUtils.CookieCrumb.prototype.getExpiration = function getExpiration() {
    return this.expiration;
  };

  /*
      PARAMETER: expiration - The number of miliseconds until the cookie expires
  */
  cookieUtils.CookieCrumb.prototype.setExpiration = function setExpiration(expiration) {
    this.expiration = expiration;
  };

  cookieUtils.CookieCrumb.prototype.getExpirationInSeconds = function getExpirationInSeconds() {
    if (this.expiration !== null && String(this.expiration) !== '' && Number(this.expiration) !== -1) {
      return parseInt(this.expiration / 1000, 10);
    }
    return this.expiration;
  };


  // Uses CookieManager to return
  cookieUtils.readCookie = function readCookie(name) {
    if (cookieUtils.cookieManager) {
      return cookieUtils.cookieManager.readCookie(name);
    }
    return null;
  };

  // Returns an object that contains the `E<n>` values from the
  // `THD_ONLINE_CHANNEL cookie
  // {E1:S8,E2:S8}
  cookieUtils.getChannelCookie = function getChannelCookie() {
    var channelCookie = cookieUtils.readCookie('THD_ONLINE_CHANNEL');
    var tmp = {};
    if (channelCookie && channelCookie.length) {
      var parts = channelCookie.split('::');
      // E1=S8::E2=S3...
      for (var i = 0; i < parts.length; i++) {
        var e = parts[i];
        var eParts = e.split('=');
        if (eParts.length) {
          tmp[eParts[0]] = eParts[1];
        }
      }
    }
    return tmp;
  };

  /*
   *   Function: getTHDUserName
   *       This function will get the username from the THD_USERNAME cookie crumb.
   *   Returns:
   *       This function returns the username of the logged in user.
   */
  cookieUtils.getTHDUserName = function getTHDUserName() {
    return cookieUtils.readCookie('THD_USERNAME');
  };

  cookieUtils.getTHDTotalCartAmount = function getTHDTotalCartAmount() {
    // The total dollar amount in the shopping cart
    return cookieUtils.readMiniCartCookie('D1');
  };

  /*
   *  Function: getTHDNumberItemsInCart
   *      This function calls the readMiniCartCookie() to get the I1 attribute of JSON object.
   *  Returns:
   *      This function returns nbrOfItemsInCart.
   */

  cookieUtils.getTHDNumberItemsInCart = function getTHDNumberItemsInCart() {
    // The number of items in the shopping cart
    return cookieUtils.readMiniCartCookie('I1');
  };

  /*
   *  Function: readMiniCartCookie
   *      This is a generic method to get read the THD_MINICART cookie crumb and return the attributes
   *      of the JSON object.
   *  Parameter: param
   *      This parameter defines the attribute of the JSON object.
   *  Returns:
   *      This function returns the attributes of the JSON object based on the input passed.
   */

  cookieUtils.readMiniCartCookie = function readMiniCartCookie(param) {
    var miniCartJsonStr = cookieUtils.readCookie('THD_MINICART');
    if (hasValue(miniCartJsonStr)) {
      var miniCartJsonObj = {};
      /* eslint-disable */
      eval('miniCartJsonObj = ' + miniCartJsonStr + ';');
      /* eslint-enable */
      // Get the JSON attribute based on the passed parameter

      if (param === 'D2') {
        return miniCartJsonObj.D2;
      } else if (param === 'I1') {
        return miniCartJsonObj.I1;
      } else if (param === 'F1') {
        return miniCartJsonObj.F1;
      } else if (param === 'D1') {
        return miniCartJsonObj.D1;
      } else if (param === 'F2') {
        return miniCartJsonObj.F2;
      }
    }
    return '';
  };

  cookieUtils.setZipCodeCookies = function setZipCodeCookies(zipcode, expiry, domain) {
    cookieUtils.setMobileCookie('THD_APPLIANCE_ZIPCODE', zipcode, expiry, domain);
    cookieUtils.setMobileCookie('THD_BODFS_ZIPCODE', zipcode, expiry, domain);
  };

  cookieUtils.getURLParameters = function getURLParameters() {
    var s1 = location.search.substring(1, location.search.length).split('&');
    var r = {};
    var s2;
    var i;
    for (i = 0; i < s1.length; i += 1) {
      s2 = s1[i].split('=');
      r[decodeURIComponent(s2[0]).toLowerCase()] = decodeURIComponent(s2[1]);
    }
    return r;
  };

  /* Parses the WC cookie  */

  cookieUtils.getWCSCookieVal = function getWCSCookieVal(cookieAlias) {
    var browserCookies = document.cookie.split('; ');
    var allCookies = browserCookies.length;
    var i;
    var wcsCookie;

    for (i = allCookies - 1; i >= 0; i -= 1) {
      if (browserCookies[i].indexOf(cookieAlias) === 0) {
        wcsCookie = browserCookies[i].split('=')[0];
        wcsCookie = cookieUtils.readBrowserCookie(wcsCookie);

        if (wcsCookie) {
          return wcsCookie.split(',')[0];
        }
      }
    }
    return null;
  };

  // Returns Store number from C4
  cookieUtils.getStoreNum = function getStoreNum() {
    var storeAddress = cookieUtils.readCookie('THD_LOCSTORE');
    var currentStore;

    if (!storeAddress) {
      return '';
    }

    currentStore = storeAddress.split('+')[0] || '';
    return currentStore;
  };

  // method for utf8 decoding used by decodingBase64 method to decode base64 string.
  privateMethods.utf8_decode = function _utf8Decode(utftxt) {
    var outputText = '';
    var index = 0;
    var char1;
    var char2;
    var char3;
    char1 = char2 = char3 = 0;

    while (index < utftxt.length) {
      char1 = utftxt.charCodeAt(index);

      if (char1 < 128) {
        outputText += String.fromCharCode(char1);
        index++;
      } else if ((char1 > 191) && (char1 < 224)) {
        char2 = utftxt.charCodeAt(index + 1);
        outputText += String.fromCharCode(((char1 & 31) << 6) | (char2 & 63));
        index += 2;
      } else {
        char2 = utftxt.charCodeAt(index + 1);
        char3 = utftxt.charCodeAt(index + 2);
        outputText += String.fromCharCode(((char1 & 15) << 12) | ((char2 & 63) << 6) | (char3 & 63));
        index += 3;
      }
    }

    return outputText;
  };

  // method decodingBase64 method to decode base64 string.
  privateMethods.decodeBase64 = function _decodeBase64(cookieString) {
    var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var output = '';
    var char1;
    var char2;
    var char3;
    var encodedChar1;
    var encodedChar2;
    var encodedChar3;
    var encodedChar4;
    var i = 0;

    var cleanCookieString = cookieString.replace(/[^A-Za-z0-9\+\/\=]/g, '');

    while (i < cleanCookieString.length) {
      encodedChar1 = _keyStr.indexOf(cleanCookieString.charAt(i++));
      encodedChar2 = _keyStr.indexOf(cleanCookieString.charAt(i++));
      encodedChar3 = _keyStr.indexOf(cleanCookieString.charAt(i++));
      encodedChar4 = _keyStr.indexOf(cleanCookieString.charAt(i++));

      char1 = (encodedChar1 << 2) | (encodedChar2 >> 4);
      char2 = ((encodedChar2 & 15) << 4) | (encodedChar3 >> 2);
      char3 = ((encodedChar3 & 3) << 6) | encodedChar4;

      output = output + String.fromCharCode(char1);

      if (encodedChar3 !== 64) {
        output = output + String.fromCharCode(char2);
      }
      if (encodedChar4 !== 64) {
        output = output + String.fromCharCode(char3);
      }
    }

    output = privateMethods.utf8_decode(output);

    return output;
  };

  cookieUtils.getSVOCID = function _getSVOCID() {
    var userCookie = cookieUtils.readCookie('THD_USER');
    var getUserID = function _getUserID(val) {
      var SVOCObj = JSON.parse(privateMethods.decodeBase64(val));
      return (typeof SVOCObj === 'object' && typeof SVOCObj.svocCustomerAccountId !== 'undefined') ? SVOCObj.svocCustomerAccountId : '';
    };
    return (userCookie) ? getUserID(userCookie) : '';
  };

  privateMethods.convertCrumbsToJson = function _convertCrumbsToJson(crumbs) {
    var propName = null;
    var crumbData = crumbs.reduce(
      function _reduce(a, b) {
        if (propName) {
          a[propName] = b;
          propName = null;
        } else {
          propName = b;
        }
        return a;
      }, {});

    return crumbData;
  };

  // Returns Adobe Cookie as Json Data
  cookieUtils.getAdobeCrumbs = function _getAdobeCrumbs() {
    var theCookie = cookieUtils.readCookie('AMCV_F6421253512D2C100A490D45%40AdobeOrg');
    var crumbs = (theCookie) ? theCookie.split('|') : [];
    if (crumbs.length > 1) {
      crumbs.shift(); // custom for adobe kill first value
    }

    return privateMethods.convertCrumbsToJson(crumbs);
  };

  return cookieUtils;
}));

